// extracted by mini-css-extract-plugin
export default {"box":"nIFqRSor","desktop":"_3kRHlUS4","mobile":"_2ruQHwyX","title":"_2W4Im19d","list":"_2XI9l70t","countriesLine":"_2TxvOZOq","seeAll":"_17Vb_PFY"};